<template>
  <div>
    {{dateField}}
  </div>
</template>

<script>

  export default {
    name: 'ColumnLocation',
    props: ['row', 'column', 'format'],
    computed: {
      dateField () {
          return this.formatDate(this.row[this.column], this.format)
      }
    }
  }
</script>
